(function () {
function init(scope) {
var root = scope || document;
var btn = root.querySelector('#retro-sound-btn');
var audio = root.querySelector('#retro-sound-audio');

if (!btn || !audio) return;

btn.addEventListener('click', function () {
if (audio.paused) {
audio.play();
btn.textContent = 'SOUND: ON';
} else {
audio.pause();
btn.textContent = 'SOUND: OFF';
}
});
}

if (document.readyState === 'loading') {
document.addEventListener('DOMContentLoaded', function () {
init(document);
});
} else {
init(document);
}

document.addEventListener('shopify:section:load', function (event) {
init(event.target);
});
})();